export default __webpack_public_path__ + "static/media/happens-next-placeholder.2d6529be.png";